import { useMutation, useQueryClient } from '@tanstack/react-query';

import { DrugsApi, type UpdateDosagesParams } from '@/api/domains/drugs.api';
import { DrugsQueryKeys } from '@/api/domains/drugs.query-keys';
import { useGlobalErrorStore } from '@/components/dialogs';

export const useUpdateDosages = (drugId?: number) => {
  const queryClient = useQueryClient();
  const { setGlobalError } = useGlobalErrorStore();

  return useMutation({
    mutationFn: async (updateParams: UpdateDosagesParams) => {
      if (drugId) {
        return DrugsApi.updateDosages(drugId, updateParams);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: DrugsQueryKeys.fetchDosages(drugId) });
    },
    onError: setGlobalError,
  });
};
